"use strict";

exports.__esModule = true;
var _ElementTree = require("./ElementTree");
Object.keys(_ElementTree).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementTree[key]) return;
  exports[key] = _ElementTree[key];
});